import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Button = ({
    onClick,
    disabled = false,
    loading = false,
    className = '',
    children,
    type = 'button',
    selected = true, // Add the new prop here
    style = {},
}) => {
    const baseClasses = 'z-10 px-4 py-2 font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sil-yellow-500';
    const colorClasses = disabled
        ? 'text-white bg-gray-400 cursor-not-allowed'
        : selected // Use the new prop here
            ? 'text-sil-red-300 bg-sil-yellow-700 hover:bg-sil-yellow-500'
            : 'bg-white text-blue-500 border border-blue-500';
    const combinedClasses = `${baseClasses} ${colorClasses} ${className}`;

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={combinedClasses}
            style={style}
        >
            {loading ? (
                <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
                children
            )}
        </button>
    );
};

export default Button;